import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { FantasyGameDetailsV2, FantasyGameService, FantasyPlayer } from '@fgb/core';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { firstValueFrom } from 'rxjs';
import { PlayerPosition } from 'src/app/shared/utilities/player-position';
@Component({
  selector: 'fgb-fantasy-player-select',
  templateUrl: './fantasy-player-select.component.html',
  styleUrls: ['./fantasy-player-select.component.scss'],
  animations: [
    trigger('fadeScale', [
      transition(':enter', [
        style({
          opacity: 0,
        }),
        animate(
          '500ms ease-out',
          style({
            opacity: 1,
          })
        ),
      ]),
      transition(':leave', [
        animate(
          '400ms ease-in',
          style({
            opacity: 0,
          })
        ),
      ]),
    ]),
  ],
})
export class FantasyPlayerSelectComponent implements OnChanges {
  @Input() gameId: number;
  @Input() gameDetails: FantasyGameDetailsV2;
  @Input() gameEnds: boolean = false;

  @ViewChild('owlCarousel', { static: false })
  owlCarousel!: CarouselComponent;

  currentCenterIndex = 0;
  pickedPlayerIndex = 0;
  pickedPlayer: FantasyPlayer | undefined = undefined;

  customOptions: OwlOptions = {
    items: 3,
    center: true,
    loop: true,
    autoWidth: false,
    startPosition: 0,

    pullDrag: false,
    mouseDrag: false,
    touchDrag: false,

    nav: true,
    dots: false,

    responsive: {
      0: {
        margin: 120,
      },
      400: {
        margin: 140,
      },
      992: {
        margin: 17,
      },
    },
  };

  constructor(private fantasyService: FantasyGameService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.gameDetails) {
      if (!this.gameDetails?.Players?.length) {
        return;
      }

      this.currentCenterIndex = 0;

      this.pickedPlayer = this.gameDetails.Players.find((x) => x.PlayerId === this.gameDetails.SelectedPlayerId);
    }
  }

  prev() {
    this.owlCarousel.prev();
  }

  next() {
    this.owlCarousel.next();
  }

  onTranslated(event: any) {
    const items = this.gameDetails.Players.length;

    // event.startPosition is the logical index (loop-safe)
    let index = event.startPosition;

    // normalize
    index = ((index % items) + items) % items;

    this.currentCenterIndex = index;
  }

  pickPlayer() {
    const selected = this.gameDetails.Players[this.currentCenterIndex];

    this.pickedPlayer = selected;

    firstValueFrom(this.fantasyService.confirmSelectionV2(this.gameId, selected.PlayerId));
  }

  editPick() {
    if (!this.pickedPlayer) return;

    const index = this.gameDetails.Players.findIndex((x) => x.PlayerId === this.pickedPlayer!.PlayerId);

    this.customOptions = {
      ...this.customOptions,
      startPosition: index,
    };

    this.currentCenterIndex = index;

    this.pickedPlayer = undefined;
    this.gameDetails.SelectedPlayerId = 0;
  }

  getPlayerPosition(positionName: string): string {
    switch (positionName?.toLowerCase()) {
      case PlayerPosition.Goalkeeper:
        return 'GK';
      case PlayerPosition.Defender:
        return 'DEF';
      case PlayerPosition.Midfielder:
        return 'MID';
      case PlayerPosition.Forward:
        return 'FOR';
      default:
        return '';
    }
  }
}
